import eq from "./eq.js";
import isArrayLike from "./isArrayLike.js";
import isIndex from "./_isIndex.js";
import isObject from "./isObject.js";
function isIterateeCall(value, index, object) {
  if (!isObject(object))
    return !1;
  var type = typeof index;
  return (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) ? eq(object[index], value) : !1;
}
export {
  isIterateeCall as default
};
//# sourceMappingURL=_isIterateeCall.js.map
